import Vue from 'vue';

export function indexList(data) {
    return Vue.axios({
        url: '/api/parent/bus/index',
        method: 'post',
        data: data
    })
}